module.exports = __webpack_public_path__ + "static/media/col-men.a184996e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/col-men.jpg
// module id = 1117
// module chunks = 33